var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 15.1673H4.66667C3.96667 15.1673 3.5 14.7007 3.5 14.0007C3.5 13.3007 3.96667 12.834 4.66667 12.834H23.3333C24.0333 12.834 24.5 13.3007 24.5 14.0007C24.5 14.7007 24.0333 15.1673 23.3333 15.1673Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 8.16732H4.66667C3.96667 8.16732 3.5 7.70065 3.5 7.00065C3.5 6.30065 3.96667 5.83398 4.66667 5.83398H23.3333C24.0333 5.83398 24.5 6.30065 24.5 7.00065C24.5 7.70065 24.0333 8.16732 23.3333 8.16732Z",
    fill: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 22.1673H4.66667C3.96667 22.1673 3.5 21.7007 3.5 21.0007C3.5 20.3007 3.96667 19.834 4.66667 19.834H23.3333C24.0333 19.834 24.5 20.3007 24.5 21.0007C24.5 21.7007 24.0333 22.1673 23.3333 22.1673Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.d1f2d00845994200bbc7391d65575142.svg";
export { ForwardRef as ReactComponent };